var _defs, _style, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 55",
    width: 65,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 65,
    height: 55,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAA4CAYAAACi2pVMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHiSURBVHgB7ZvtVYMwFECvHv/bEbKBjlA30AlkA92gbtA6gTpBdYLWCRyBOkHdoCYBzukJif2AlCDvnvN+EBoaLoTC6wPiM9LxqGOhY61j01GsyzFknBilI6e7HQ9FXo4tOoo0BWyfGddE5gvYJB4LM9Az4jCuvsBhqWNFNyiKcbncEIkZdeuPdE9GfVwzIjGnPv9SIceZEufEYeQs/5AwsST0CpGASLCIBESCRSQgEiwiAZFgEQmIBItI0FwE2s0DkOL4zMuIHuFKMIN/oHj279WONGFbgqLIBikGRnVNUAxUgKGSMGGgAgzVdBh71j3reOc4ppwgnd0WRoIZrHLaX2mWGE06neZipoPvV+CDARG6WerVkWyK3DEiEiwiAZFgEQmIBItIQCRYRAIiwSISEAkWkYBIsIQkDCbTbDASfLmDtiUkX7i18rQ3zQ+6/ZOXYAa4ctrvOf5syDx9P+kBvgrUKYdjdj73bCulzHOtmLNaofAXQE/YHyPAV9S9IC2CEgy+s8HEC7v/mBkTLuvf1feUZHhqm7er3KsjqQIbWFJcO77L5cuyz/iPPubzb6TBlY5bT/ud26BI+0WNtiMngGIYItbsMVWf/rGMg179URQXkzndvsnWVuQUB3dQjwV78Qsv4dmN3/J1nAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 16,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACCSURBVHgBrZFbDYAwDEVvggFwMAlIQMocTAJzgASkYAEHSIEugYSQPfrgJudnWc/atYM9ngjEQOwwZibOFxGGfGWJA8rkZIkVipRkqTsHYdiycB9uKL/Clnm0WxeNGRsXxX82VQoWqaw0dg32Nv2fMo5ULKtJ1bKc1Cx74oiR6CVFFzB4b0RVGidpAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 15,
    height: 5,
    id: "img3",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAFCAYAAACaTbYsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABSSURBVHgBnc1dFYAgDIbhYQGJYBQbWAETaBSjaQJpAA3g3YF7fr5znp3tYpuRkgu39CXixKuDQxoUYBfKJuOxWLXZJz7/umjqJYejXmzlwwOfASTBIKpKv0WsAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 5,
    id: "img4",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAFCAYAAABfPyy9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABRSURBVHgBtdFRDQAgCARQNIFRjGADbWAGG1jBJkYxAg20gR7TCHLb2+ALBoZuEmRw9CcLCrA0AbaCKQvbN0Ajcg0vAwbphc0rKkT69wOGBv0A8LYeYbCrnXkAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Clip path group (3)",
    href: "#img1",
    transform: "matrix(1,0,0,1,0,0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Vector",
    href: "#img2",
    transform: "matrix(1,0,0,1,32,10)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "Vector (1)",
    href: "#img3",
    transform: "matrix(1,0,0,1,32,31)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "Vector (2)",
    href: "#img4",
    transform: "matrix(1,0,0,1,32,41)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintShip);
export default __webpack_public_path__ + "static/media/print_ship.11cee176c54d6cbe387c2df5219c3380.svg";
export { ForwardRef as ReactComponent };